export default __webpack_public_path__ + "static/media/aws-cloudsearch.2ea8c58e.svg";